var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotationsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "22px",
    viewBox: "0 0 17 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-file-5105658") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---1---main-Copy",
    transform: "translate(-31.000000, -201.000000)",
    fill: "#435971",
    fillRule: "nonzero",
    stroke: "#435971",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Menu"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(17.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-2",
    transform: "translate(15.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-file-5105658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1363636,0.0303106061 L5.58143939,0.0303106061 C5.46898485,0.0303106061 5.36097348,0.0750265152 5.28151515,0.154628788 L0.154621212,5.28152273 C0.0750151515,5.36112879 0.0303333333,5.46899242 0.0303333333,5.58144697 L0.0303333333,18.9090985 C0.0303333333,19.4938712 0.506166667,19.9697045 1.09093939,19.9697045 L14.1363939,19.9697045 C14.7211667,19.9697045 15.197,19.4938712 15.197,18.9090985 L15.197,1.09091667 C15.197,0.506143939 14.7211667,0.0303106061 14.1363939,0.0303106061 L14.1363636,0.0303106061 Z M5.15719697,1.47875 L5.15719697,5.15727273 L1.47867424,5.15727273 L5.15719697,1.47875 Z M14.3484848,18.909053 C14.3484848,19.0259432 14.2533447,19.1212348 14.136303,19.1212348 L1.09084848,19.1212348 C0.973810606,19.1212348 0.878666667,19.0260947 0.878666667,18.909053 L0.878666667,6.00564394 L5.58131818,6.00564394 C5.81554545,6.00564394 6.00552273,5.81565909 6.00552273,5.58143939 L6.00552273,0.878787879 L14.1362045,0.878787879 C14.2532424,0.878787879 14.3484848,0.97392803 14.3484848,1.0909697 L14.3484848,18.909053 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationsMenu);
export default __webpack_public_path__ + "static/media/Quotations-menu.acee1611e336dcff3f2d5a53b4b2a435.svg";
export { ForwardRef as ReactComponent };